const initialState = {
  policies: {
    status: 26,
    steps: [
      {
        order: 0,
        label: 'Información básica',
        type: '',
        isOptional: false
      },
      {
        order: 1,
        label: 'Incentivos',
        type: '',
        isOptional: false
      }
    ],
    currentStep: {
      order: 0,
      label: 'Información básica',
      type: '',
      isOptional: false
    },
    listIncentives: [],
    incetiveValues: [
      { price: {} },
      { salesQuantity: {} },
      { takingCar: {} },
      { opportunity: {} },
      { profitability: {} }
    ],
    listIncentiveCardsSuccess: false,
    basicInformation: {
      carLotId: '',
      carLotName: '',
      saleType: '',
      branchId: '',
      branchName: '',
      commissionMonth: '',
      commissionPeriod: '',
      commissionName: '',
      comission_policy_name: '',
      comission_policy_state: '',
      comission_policy_state_id: '',
    },
    getNewCommissionMonthPending: false,
    getNewCommissionMonthSuccess: false,
    newCommissionMonth: null,
    getNewCommissionMonthError: null,
    createComissionPolicyPending: false,
    createComissionPolicyError: null,
    incentivesSuccess: null,
    createNewCommissionMonthPending: false,
    createNewCommissionMonthSuccess: false,
    createNewCommissionMonthError: null,
    patchCommissionPolicyPending: false,
    patchCommissionPolicySuccess: false,
    patchCommissionPolicyError: null,
    getCommissionsStatePending: false,
    getCommissionsStateSuccess: false,
    getCommissionsStateError: null,
    listCommissionsStates: null,
    updateCommissionMonthPending: false,
    updateCommissionMonthSuccess: false,
    updateCommissionMonthError: null,
    updatePolicyStatusSuccess: false,
    updatePolicyStatusPending: false,
    getPolicySuccess:false,
    getPossibleActionsSuccess:false,
    commissionPolicyPossibleActions: [],
    editCommissionMonthRange: {
      validity_from_date: '',
      validity_to_date: ''
    },
    getRangeCommissionMonthPending: false,
    getRangeCommissionMonthSuccess: false,
    getRangeCommissionMonthError: null,
    getCommissionsPeriodsPending: false,
    getCommissionsPeriodsSuccess: false,
    getCommissionsPeriodsError: null,
    listCommissionsPeriods: [],
    commissionsMonths: [],
    getCommissionsMonthPending: false,
    createPolicyCopyPending: false,
    createPolicyCopyError: false,
    createPolicyCopySuccess: false,
    branchOfficeOptions: [],
    stockData: [],
    brands:[],
    stockLoading: false,
    stockFailure: false,
    opportunityIncentiveProduct: []
  },
  commissionPolicy: {},
  commissionList:{
    data:[],
    carlotOptions:[],
    commercialAdvisorOptions:[],
    carlotDefault:null,
    dataStateMachine: [],
    periodsOptions: [],
    reportPending: false,
    reportSuccess: false,
    errorMessage: null,
    refreshDate: null
    
  },
}

export default initialState

